import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_team_management-set_role_and_permissions-click';
/**
 * Click event for set roles and permissions button on lean invite toast
 */
export function trackRetailerTeamManagementSetRoleAndPermissionsClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
